import axios from 'axios';

import {
    APPOINTMENT_SERVICE_RECEIVE, APPOINTMENT_SERVICE_FAILURE
} from '../constants/appointment';

export const getAppointmentServices = () => (dispatch) => {
    fetch('/api/get-services')
        .then((response) => {
            response.json()
                .then((data) => {
                    dispatch({
                        type: APPOINTMENT_SERVICE_RECEIVE,
                        payload: data
                    });
                });
        })
        .catch((error) => {
            dispatch({ type: APPOINTMENT_SERVICE_FAILURE });
        })
};


export const appointmentValidate = (data, callback, errorCallback) => (dispatch) => {
    axios.post('/api/appointment-validate', data, { headers: { 'Content-Type': 'application/json' } })
        .then((response) => {
            if (response.data.length === 0) {
                axios.post('/api/appointment-create', data, {headers: {'Content-Type': 'application/json'}})
                    .then((recordJson) => {
                        if(recordJson.data.status === 'success'){
                            callback(recordJson.data);
                        } else {
                            errorCallback(recordJson.data);
                        }
                    });
            } else {
                errorCallback(response.data);
            }
        })
        .catch((error) => {
            dispatch({ type: APPOINTMENT_SERVICE_FAILURE });
        })
};

export const resetAppointment = () => {};



// WEBPACK FOOTER //
// frontend/src/modules/mobile/actions/appointment.js